// extracted by mini-css-extract-plugin
export default {"processStepTable":"processStepTable-VmBSD","bigMessage":"bigMessage-m88FN","instrumentName":"instrumentName-phYYt","commandName":"commandName-tfTiR"};